import { Routes } from '@angular/router';
import { RicheditComponent } from './pages/sia-richedit-page/sia-richedit-page.component';
import { SiaSystemFileArchivesPageComponent } from './pages/sia-system-file-archives-page/sia-system-file-archives-page.component';

export const ROUTES: Routes = [
  {
    path: 'system-files/:guid',
    component: SiaSystemFileArchivesPageComponent,
  },
  {
    path: 'richedit/:guid',
    component: RicheditComponent,
  },
];
